<template>
  <div class="order">
    <van-nav-bar title="宿舍刷卡记录" left-arrow @click-left="$router.go(-1)" />
    <van-cell title="开始日期" :value="starttime" @click="showDate('start')" />
    <van-cell title="结束日期" :value="endtime" @click="showDate('end')" />
    <van-calendar v-model="show" @confirm="onConfirm" :min-date="minDate" :max-date="maxDate" :show-confirm="false"/>
    <van-button type="primary" class="search-btn" block  @click="getList">开始查询</van-button>
    <div v-if="list.length==0">
      <van-empty description="暂无记录" />
    </div>
    <div v-else>
        <van-cell-group class="access_box" v-for="item in list" :key="item.id">
          <van-cell  title="宿舍楼" :value="item.address" />
          <van-cell  title="经过时间" :value="item.pass_time" />
          <van-cell  title="出入标识" :value="item.punch_type" />
        </van-cell-group>
     
    </div>
  </div>
</template>

<script>

import { getDormAccessList } from '@/api/home'



export default {
  name: 'DormAccess',
  components: {
    
  },
  data () {
    return {
      show: false,
      starttime: new Date().toLocaleDateString(),
      endtime: new Date().toLocaleDateString(),
      datetype:'',
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2040, 0, 31),
      page: 1,
      list: [],
      childrenInfo:{}

    }
  },
  mounted () {
    this.childrenInfo=JSON.parse(localStorage.getItem('childrenInfo'))
    this.getList()
  },
  methods: {
    async getList () {
      if(!this.starttime || !this.endtime){
        this.$toast('请选择开始结束日期')
        return
      } 
      let params={
        starttime: this.starttime,
        endtime: this.endtime,
        rfid:this.childrenInfo.rfid
      }

      const response = await getDormAccessList(params)
      console.log('response', response);
      this.list = response.data
    },
    showDate(type) {
      this.datetype=type

      this.show = true
    
    },

    formatDate(date) {
       return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      if(this.datetype==='start'){
        this.starttime = this.formatDate(date);
      }else{
        this.endtime = this.formatDate(date);
      }
      
    },

  },
  watch: {
    
  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}
.van-tabs {
  position: sticky;
  top: 0;
}
.search-btn{
  background-color: #04be02;
  color: #fff;
  width: 90%;
  margin: 0 auto;
  font-size: 16px;
  border-radius: 10px;

}
.access_box{
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
